export const footerLinks = {
  usefulLinks: {
    head: "Useful Links",
    links: ["Home", "About", "Services", "Portfolio", "Contact"],
  },
  servicesLinks: {
    head: "Our Services",
    links: [
      "Web Design",
      "Web Development",
      "Product Management",
      "Marketing",
      "Graphic Design",
    ],
  },
};
